import { axiosObj } from './api.service'

export const getPatientDetailsService = async (
  patientId: string,
  jwtToken: string
): Promise<any> => {
  try {
    const { data }: { data: any } = await axiosObj({
      jwtToken,
    }).get(`patients/${patientId}`)
    return data
  } catch (e) {
    throw e
  }
}

export const getDayTrainingLogs = async (jwtToken: string): Promise<any> => {
  try {
    const { data }: { data: any } = await axiosObj({
      jwtToken,
    }).get('dayTrainings')
    return data
  } catch (e) {
    throw e
  }
}

export const getPatientSharedService = async (
  patientId: string,
  jwtToken: string
): Promise<any> => {
  try {
    const { data }: { data: any } = await axiosObj({
      jwtToken,
    }).get(`/patients/${patientId}/dayTrainingLogs/shared`)
    return data
  } catch (e) {
    throw e
  }
}
export const putPatientSharedService = async (
  patientId: string,
  jwtToken: string,
  enable: boolean,
  password: string
): Promise<any> => {
  try {
    const { data }: { data: any } = await axiosObj({
      jwtToken,
    }).put(`/patients/${patientId}/dayTrainingLogs/shared`, {
      enable: enable,
      password: password,
    })
    return data
  } catch (e) {
    throw e
  }
}



// WEBPACK FOOTER //
// ./src/services/patient.service.tsx